module.exports = __webpack_public_path__ + "components/resort-nearby-resorts/static/no-webcam-3b0fac06e2155079893edacb855eef8f.svg";